import { Flame, Award } from 'lucide-react'
import { ModalOverlay } from './ModalOverlay'
import { TuCoinIcon } from '../TuCoinIcon'

const F = 'Roboto, sans-serif'

interface Props {
  open: boolean
  onClose: () => void
  xpEarned?: number
  coinsEarned?: number
  streakDays?: number
  rank?: number
  leagueName?: string
}

export function WeeklyResultsModal({ open, onClose, xpEarned = 78, coinsEarned = 5, streakDays = 12, rank = 8, leagueName = 'Серебряная' }: Props) {
  return (
    <ModalOverlay open={open} onClose={onClose} borderGradient="linear-gradient(135deg, #FFD60A, #FF9500)">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: F, gap: 16 }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1C2D41', margin: 0 }}>Итоги недели</h2>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, width: '100%' }}>
          {[
            { icon: <Award size={20} color="#4A9FE5" />, label: 'XP за неделю', value: `+${xpEarned}`, color: '#4A9FE5' },
            { icon: <TuCoinIcon size={20} />, label: 'TuCoin', value: `+${coinsEarned}`, color: '#B85C00' },
            { icon: <Flame size={20} color="#F97316" />, label: 'Дни в режиме', value: `${streakDays} дн.`, color: '#F97316' },
            { icon: <Award size={20} color="#C0A060" />, label: leagueName, value: `#${rank}`, color: '#C0A060' },
          ].map((item, i) => (
            <div key={i} style={{ borderRadius: 14, padding: '12px 10px', background: `${item.color}10`, border: `1px solid ${item.color}20`, textAlign: 'center' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 4 }}>{item.icon}</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: item.color }}>{item.value}</div>
              <div style={{ fontSize: 11, color: '#6B7B8D', marginTop: 2 }}>{item.label}</div>
            </div>
          ))}
        </div>

        <button onClick={onClose} style={{ width: '100%', height: 52, borderRadius: 16, border: 'none', background: 'linear-gradient(135deg, #1A3A5C, #4A6CF7)', color: 'white', fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: F }}>
          Отлично!
        </button>
      </div>
    </ModalOverlay>
  )
}
